module.exports = __webpack_public_path__ + "img/paying@2x.c9dd7b88.png";